import { hasFeatureAccess } from '@shared/featureFlagEvaluation';
import type { RoleId } from '@shared/roles';
import type { TeamPolicy } from '@shared/teamPolicy';

interface TeamPolicyUser {
  role?: RoleId | string | null;
  featureFlags?: Map<string, boolean> | Readonly<Record<string, boolean>>;
  teamPolicy?: TeamPolicy | null;
}

export function hasEffectiveFeatureAccess(
  user: TeamPolicyUser | null | undefined,
  featureId: string
): boolean {
  if (!user?.role) return false;
  return hasFeatureAccess(user as never, featureId);
}

export function isRouteHiddenByTeamPolicy(
  route: string,
  policy: TeamPolicy | null | undefined
): boolean {
  if (!route || !policy) return false;
  if (
    policy.uiPolicy.hideClassCodeUi &&
    (route === '/class' || route === '/teacher/class-codes')
  ) {
    return true;
  }
  return false;
}
